import { Box, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';

import DisclosureGuidelinesBusinessValueChains from '../../Components/DisclosureGuidelines/DisclosureGuidelinesBusinessValueChains';
import BusinessValueChainIntroduction, {
  BUSINESS_INTRODUCTION_ID,
} from './BusinessValueChainIntroduction';
import BusinessValueChainRemark, {
  BUSINESS_REMARK_ID,
} from './BusinessValueChainRemark';
import BusinessValueChainsForm from './BusinessValueChainsForm';
import BusinessValueChainsFormComplete from './BusinessValueChainsFormComplete';
import BusinessValueChainUploadImage from './BusinessValueChainUploadImage';

const BusinessValueChains = () => {
  return (
    <Box>
      <Box p={2} bgcolor={'white'}>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Flex gap={1}>
            <Typography fontWeight={700}>ห่วงโซ่คุณค่าธุรกิจ</Typography>
            <Flex gap={0.5} alignItems={'center'}>
              <BusinessValueChainIntroduction />
              <BusinessValueChainRemark />
            </Flex>
          </Flex>

          <DisclosureGuidelinesBusinessValueChains />
        </Flex>
        <Box id={BUSINESS_INTRODUCTION_ID} />
        <Box mt={2}>
          <BusinessValueChainsForm />
        </Box>
        <BusinessValueChainUploadImage />
        <Box id={BUSINESS_REMARK_ID} />
      </Box>
      <BusinessValueChainsFormComplete />
    </Box>
  );
};
export default BusinessValueChains;
